var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{attrs:{"action":"fakeaction","http-request":_vm.handleUpload,"multiple":false,"show-file-list":false,"before-upload":_vm.beforeUpload,"drag":false,"on-success":_vm.onSuccess}},[[_c('button',{style:(_vm.preViewFileUrl?'background-image:url('+_vm.preViewFileUrl+')':'')},[_vm._v(_vm._s(_vm.tips))])]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d980942c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/axj-upload/index.vue
// module id = null
// module chunks = 